/**
 * کش سبک برای هدف شخصی هدر (my-goal)
 * جلوگیری از درخواست تکراری هنگام remount شدن MainLayout در هر ناوبری
 */

const DEFAULT_TTL_MS = 5 * 60 * 1000; // ۵ دقیقه

let cachedPayload = undefined; // undefined = هنوز لود نشده؛ null = بدون هدف / خطا
let cachedAt = 0;
let inflight = null;

const isFresh = (ttlMs = DEFAULT_TTL_MS) =>
  cachedPayload !== undefined && Date.now() - cachedAt < ttlMs;

/**
 * دریافت هدف شخصی با کش و اشتراک درخواست در حال اجرا
 * @param {() => Promise<any>} fetcher
 * @param {{ force?: boolean, ttlMs?: number }} [options]
 */
export async function getCachedMyGoal(fetcher, options = {}) {
  const { force = false, ttlMs = DEFAULT_TTL_MS } = options;

  if (!force && isFresh(ttlMs)) {
    return cachedPayload;
  }

  if (!force && inflight) {
    return inflight;
  }

  inflight = Promise.resolve()
    .then(() => fetcher())
    .then((res) => {
      cachedPayload = res?.data ?? res ?? null;
      cachedAt = Date.now();
      return cachedPayload;
    })
    .catch((err) => {
      // در خطا کش قبلی را نگه می‌داریم تا UI خالی نشود
      if (cachedPayload === undefined) {
        cachedPayload = null;
        cachedAt = Date.now();
      }
      throw err;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

/** باطل‌سازی کش — بعد از ذخیره/حذف هدف صدا بزنید */
export function invalidateMyGoalCache() {
  cachedPayload = undefined;
  cachedAt = 0;
  inflight = null;
}

/** جایگزینی مستقیم کش (مثلاً بعد از سوئیچ goal_id در هدر) */
export function setMyGoalCache(payload) {
  cachedPayload = payload ?? null;
  cachedAt = Date.now();
  inflight = null;
}

export function peekMyGoalCache() {
  return isFresh() ? cachedPayload : undefined;
}
